import axios from "axios";
import { API } from "@/App";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window;

export const subscribePush = async (token) => {
  const registration = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  await axios.post(
    `${API}/push/subscribe`,
    { subscription: subscription.toJSON(), timezone },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const unsubscribePush = async (token) => {
  const registration = await navigator.serviceWorker.getRegistration("/sw.js");
  const subscription = await registration?.pushManager.getSubscription();
  if (subscription) {
    await axios.post(
      `${API}/push/unsubscribe`,
      { endpoint: subscription.endpoint },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    await subscription.unsubscribe();
  }
};

export const sendTestPush = async (token) => {
  const { data } = await axios.post(`${API}/push/test`, {}, { headers: { Authorization: `Bearer ${token}` } });
  return data;
};
